import moment from "moment";
import axios from "axios";
import { URL } from '../../env';
import  { orderBy } from 'lodash'
export default {
    data: () => ({
        userpermission: {},
        syndicates: [],
        check_permission: {},
        loadingSpin: false,
        currentSyndicate: {
            is_cash_balance: 0,
            show_quick_view_tab: 0,
            show_detailed_view_tab: 0,
            deals_tab: 0,
        },
        mainSyndicate: {
            is_cash_balance: 0,
            show_quick_view_tab: 0,
            show_detailed_view_tab: 0,
            deals_tab: 0,
        },
        selected_syndicate_id: parseInt(localStorage.getItem('syndication_id')),
    }),
  
    mounted() {
        this.getMainSyndicateProfile()
        this.getProfile()
        this.getUserPermission();
    },
    methods: {
        async getUserPermission(){
            return await axios.get(`${URL}/api/user_permission/user_permissions/` + localStorage.getItem('user_id'))
                .then(res => {
                    this.userpermission = res.data.length > 0 ? res.data[0] : {}
                    if(this.userpermission.syndcation_manager) this.getSyndicates()
                });
        },
        async getSyndicates(){
            return await axios.get(`${URL}/api/syndicate/get_compact_syndicates`, {
                params: {
                    user_id: this.userpermission.user_id
                }
            })
                .then(res => {
                    this.syndicates = orderBy(res.data.data, ["syndicate_abbreviation"], ["asc"]);
                });
        },
        async changeSyndicate(){
            const resp = await this.checkPermission()
            if(!resp.syndcation_manager){
                alert('You dont have the access to switch accounts.')
                let id = localStorage.getItem('main_syndication_id')
                let name = localStorage.getItem('main_name')
                localStorage.setItem('syndication_id', id)  
                localStorage.setItem('name', name)    
                location.reload();
                return
            }
            localStorage.setItem('last_syndication_id', this.selected_syndicate_id)   
            localStorage.setItem('syndication_id', this.selected_syndicate_id)
            let filtered = _.filter(this.syndicates, o=> o.id == this.selected_syndicate_id)
            localStorage.setItem('selected_user_id', filtered[0].user_id)
            // if(filtered.length) {
            //     this.currentSyndicate = filtered.length > 0 ? filtered[0] : {};
            // }
            localStorage.setItem('name', filtered[0].syndicate_name)
            location.reload();
        },
        async checkPermission(){
            const resp =  await axios.get(`${URL}/api/user_permission/user_permissions/` + localStorage.getItem('user_id'))
            return resp.data.length > 0 ? resp.data[0] : {}
           
        },
        async getMainSyndicateProfile() {
            let  app  = this
            const mainUserId = localStorage.getItem("user_id")
            let userId = mainUserId;
            this.loadingSpin = true;
            const resp = await axios.get(`${URL}/api/getPortalUserProfile/${userId}`);
            
            // if master account  login
            let syndManager = this.userpermission.syndcation_manager
            // if mainUserId  is in masterUserIds  then  dont  change the show_quick_view_tab,  show_detailed_view_tab
            if(syndManager && mainUserId != userId){
                const mainUserResp = await axios.get(`${URL}/api/getPortalUserProfile/${mainUserId}`);
                this.mainSyndicate = resp.data.length > 0 ? {
                    ...resp.data[0].syndication,
                    show_quick_view_tab: mainUserResp.data.length > 0 ? mainUserResp.data[0].syndication.show_quick_view_tab : 0,
                    show_detailed_view_tab: mainUserResp.data.length > 0 ? mainUserResp.data[0].syndication.show_detailed_view_tab : 0,
                    deals_tab: mainUserResp.data.length > 0 ? mainUserResp.data[0].syndication.deals_tab : 0,
                } : {};

            } else {
                this.mainSyndicate = resp.data.length > 0 ? resp.data[0].syndication : {};
            }
            this.loadingSpin = false
        },
        async getProfile() {
            let  app  = this
            const mainUserId = localStorage.getItem("user_id")
            let userId = localStorage.getItem("selected_user_id") || mainUserId;
            this.loadingSpin = true;
            const resp = await axios.get(`${URL}/api/getPortalUserProfile/${userId}`);
            
            // if master account  login
            let syndManager = this.userpermission.syndcation_manager
            // if mainUserId  is in masterUserIds  then  dont  change the show_quick_view_tab,  show_detailed_view_tab
            if(syndManager && mainUserId != userId){
                const mainUserResp = await axios.get(`${URL}/api/getPortalUserProfile/${mainUserId}`);
                this.currentSyndicate = resp.data.length > 0 ? {
                    ...resp.data[0].syndication,
                    show_quick_view_tab: mainUserResp.data.length > 0 ? mainUserResp.data[0].syndication.show_quick_view_tab : 0,
                    show_detailed_view_tab: mainUserResp.data.length > 0 ? mainUserResp.data[0].syndication.show_detailed_view_tab : 0,
                    deals_tab: mainUserResp.data.length > 0 ? mainUserResp.data[0].syndication.deals_tab : 0,
                } : {};

            } else {
                this.currentSyndicate = resp.data.length > 0 ? resp.data[0].syndication : {};
            }
            this.loadingSpin = false
        },
    }

  
};